<template>
  <v-card flat height="85vh">
    <v-tabs icons-and-text>
      <v-tab v-for="tab in tabs" :key="tab.title">
        {{ tab.title }}
        <v-icon left>{{ tab.icon }}</v-icon>
      </v-tab>
      <v-tab-item>
        <TicketsConfig />
      </v-tab-item>
      <v-tab-item>
        <CajaConfig />
      </v-tab-item>
    </v-tabs>
  </v-card>
</template>
<script>
import TicketsConfig from "./TicketsConfig.vue";
import CajaConfig from "./CajaConfig.vue";
export default {
  components: {
    TicketsConfig,
    CajaConfig,
  },
  data() {
    return {
      tabs: [
        { title: "Tickets", icon: "mdi-tray-full" },
        { title: "Caja", icon: "mdi-cash-register" },
      ],
    };
  },
};
</script>
<style>
.config__input-container {
  width: 100%;
  margin-bottom: 15px;
  display: flex;
  justify-content: center;
  color: white;
}

.config__input {
  font-size: 48px;
  font-weight: bold;
  color: inherit;
}

.config__input--sm {
  max-width: 20%;
}

.config__input--md {
  max-width: 40%;
}

.config__input--lg {
  max-width: 50%;
}
</style>